(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-dispatch-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pdpDispatchReady) return;
    window.__pdpDispatchReady = true;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function render(el, template, time) {
      var text = el.querySelector('.pdp-dispatch__text');
      text.textContent = '';
      var parts = template.split('{time}');
      parts.forEach(function (part, i) {
        text.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) {
          var strong = document.createElement('strong');
          strong.textContent = time;
          text.appendChild(strong);
        }
      });
    }

    function tick() {
      var ist = new Date(Date.now() + 330 * 60000);
      var nowSec = ist.getUTCHours() * 3600 + ist.getUTCMinutes() * 60 + ist.getUTCSeconds();
      var day = ist.getUTCDay();

      document.querySelectorAll('.pdp-dispatch').forEach(function (el) {
        var cutoffSec = parseInt(el.dataset.cutoffH, 10) * 3600 + parseInt(el.dataset.cutoffM, 10) * 60;
        var closedToday = el.dataset.skipSunday === 'true' && day === 0;

        if (nowSec < cutoffSec && !closedToday) {
          var left = cutoffSec - nowSec;
          var time = pad(Math.floor(left / 3600)) + 'h ' + pad(Math.floor((left % 3600) / 60)) + 'm ' + pad(left % 60) + 's';
          render(el, el.dataset.before, time);
        } else {
          render(el, el.dataset.after, '');
        }
      });
    }

    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-testimonial-video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pdpTvReady) return;
    window.__pdpTvReady = true;

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) return;
            var v = entry.target;
            if (!v.paused) {
              v.pause();
              v.closest('.pdp-tv__frame').classList.remove('is-playing');
            }
          });
        },
        { threshold: 0.25 }
      );
    }

    function toggle(frame) {
      var video = frame.querySelector('video');
      if (!video) return;

      if (video.paused) {
        document.querySelectorAll('.pdp-tv__frame video').forEach(function (other) {
          if (other !== video && !other.paused) {
            other.pause();
            other.closest('.pdp-tv__frame').classList.remove('is-playing');
          }
        });
        video.muted = false;
        frame.classList.remove('is-muted');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
        if (observer) observer.observe(video);
      } else {
        video.pause();
        frame.classList.remove('is-playing');
      }
    }

    document.addEventListener('click', function (e) {
      var soundBtn = e.target.closest('.pdp-tv__sound');
      if (soundBtn) {
        var f = soundBtn.closest('.pdp-tv__frame');
        var v = f.querySelector('video');
        v.muted = !v.muted;
        f.classList.toggle('is-muted', v.muted);
        return;
      }
      var frame = e.target.closest('.pdp-tv__frame');
      if (frame) toggle(frame);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var frame = e.target.closest && e.target.closest('.pdp-tv__frame');
      if (!frame || e.target.closest('.pdp-tv__sound')) return;
      e.preventDefault();
      toggle(frame);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pdpTvReady) return;
    window.__pdpTvReady = true;

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) return;
            var v = entry.target;
            if (!v.paused) {
              v.pause();
              v.closest('.pdp-tv__frame').classList.remove('is-playing');
            }
          });
        },
        { threshold: 0.25 }
      );
    }

    function toggle(frame) {
      var video = frame.querySelector('video');
      if (!video) return;

      if (video.paused) {
        document.querySelectorAll('.pdp-tv__frame video').forEach(function (other) {
          if (other !== video && !other.paused) {
            other.pause();
            other.closest('.pdp-tv__frame').classList.remove('is-playing');
          }
        });
        video.muted = false;
        frame.classList.remove('is-muted');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        frame.classList.add('is-playing');
        if (observer) observer.observe(video);
      } else {
        video.pause();
        frame.classList.remove('is-playing');
      }
    }

    document.addEventListener('click', function (e) {
      var soundBtn = e.target.closest('.pdp-tv__sound');
      if (soundBtn) {
        var f = soundBtn.closest('.pdp-tv__frame');
        var v = f.querySelector('video');
        v.muted = !v.muted;
        f.classList.toggle('is-muted', v.muted);
        return;
      }
      var frame = e.target.closest('.pdp-tv__frame');
      if (frame) toggle(frame);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var frame = e.target.closest && e.target.closest('.pdp-tv__frame');
      if (!frame || e.target.closest('.pdp-tv__sound')) return;
      e.preventDefault();
      toggle(frame);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
